import { FeaturedIcon } from '@unified-checkout/design-system';
import { ChevronRight } from '@unified-checkout/design-system/icons/index';
import { classNames } from 'apps/customer/src/utils';
import { Link } from 'react-router-dom';

interface ISingleCardProps {
  icon?: JSX.Element;
  title: string;
  text?: string;
  supportingText?: string;
  withoutChevron?: boolean;
  titleColor?: 'red' | 'lightGray' | 'darkGray';
  onClickHandler?: () => void;
}
export const SingleCard = ({
  icon,
  title,
  text,
  withoutChevron,
  titleColor = 'darkGray',
  onClickHandler,
}: ISingleCardProps) => {
  const titleMappedColor = {
    red: 'text-red-500',
    darkGray: 'text-gray-900',
    lightGray: 'text-gray-500',
  };

  return (
    <div
      className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg cursor-pointer md:bg-white "
      onClick={onClickHandler}
    >
      {icon && <FeaturedIcon color="primary" icon={icon} size="sm" />}
      <div
        className={classNames(
          'flex  grow english-body-sm-semibold',
          icon ? 'justify-between' : 'justify-center'
        )}
      >
        <p className={titleMappedColor[titleColor]}>{title}</p>
        {text && (
          <Link className="text-primary-500" to={'/add-passkey'}>
            {text}
          </Link>
        )}
      </div>
      {!withoutChevron && (
        <div className="[&_path]:fill-gray-500 size-5">{ChevronRight}</div>
      )}
    </div>
  );
};
